import type { SKUFormSchema } from '@/_pages/settings/inventory-kits/shared/schemas/skus';

export const defaultValues: Readonly<SKUFormSchema> = {
  id: -1,
  sku: '',
  pivot: {
    primary: 0,
  },
  intent: 'create',
  // using this to set change in form
  // to differentiate between create and update
  localMatchId: undefined,
  setDirtyHelper: false,
} as const;
